var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2996 21.2304L17.9583 22.8891L21.2758 19.5717",
    stroke: "#233F39",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8119 12.304C13.7027 12.293 13.5718 12.293 13.4518 12.304C10.8545 12.2167 8.79203 10.0887 8.79203 7.46963C8.78112 4.79602 10.9527 2.62439 13.6264 2.62439C16.3 2.62439 18.4716 4.79602 18.4716 7.46963C18.4716 10.0887 16.3982 12.2167 13.8119 12.304Z",
    stroke: "#233F39",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6259 24.2421C11.6398 24.2421 9.66459 23.7401 8.15863 22.7362C5.51776 20.9683 5.51776 18.0874 8.15863 16.3304C11.1596 14.3225 16.0813 14.3225 19.0822 16.3304",
    stroke: "#233F39",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlus);
export default __webpack_public_path__ + "static/media/profilePlus.f114223067ec39ebb11c0458bf7a8b7f.svg";
export { ForwardRef as ReactComponent };